const topics = [
  { label: '#韩漫推荐', count: '12.8万讨论', active: true },
  { label: '#今日更新', count: '9.6万讨论', active: true },
  { label: '#日漫新番', count: '8.3万讨论', active: false },
  { label: '#国漫崛起', count: '7.5万讨论', active: true },
  { label: '#完结神作', count: '6.2万讨论', active: false },
  { label: '#漫画推荐', count: '5.9万讨论', active: true },
  { label: '#漫评交流', count: '4.7万讨论', active: false },
  { label: '#汉化进度', count: '3.8万讨论', active: true },
  { label: '#动画化', count: '3.2万讨论', active: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-accent-100 text-accent-800 mb-3 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            加入漫友讨论，分享你的阅读感受和追更心得
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer ${
                topic.active
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#topics"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部话题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}